import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import * as Sentry from '@sentry/angular';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const messages = inject(MessageService);

  return next(req).pipe(
    catchError(err => {
      // 5xx server errors — show generic toast
      if (err.status >= 500) {
        messages.add({
          severity: 'error',
          summary: 'Greška servera',
          detail: 'Došlo je do greške. Pokušaj ponovo.',
          life: 5000,
        });
        Sentry.captureException(err);
      }
      // 0 = network error
      if (err.status === 0) {
        messages.add({
          severity: 'warn',
          summary: 'Nema veze',
          detail: 'Provjeri internetsku vezu.',
          life: 5000,
        });
        Sentry.captureException(err);
      }
      return throwError(() => err);
    }),
  );
};
